import PartnerPageHero from '@/components/partner/PartnerPageHero';
import PartnerInquiryForm from '@/components/partner/PartnerInquiryForm';

function PartnerConnectPage() {
  return (
    <div className="fhxd-chrome-top">
      <PartnerPageHero ctaLabel="Partner Opportunities" ctaHref="/partner-opportunities" />
      <PartnerInquiryForm source="partner-connect" />
    </div>
  );
}

export default PartnerConnectPage;
